import i18n from "@/lang";
import dayjs from "dayjs";
import isToday from "dayjs/plugin/isToday";
import isYesterday from "dayjs/plugin/isYesterday";
import relativeTime from "dayjs/plugin/relativeTime";
import { useI18n } from "vue-i18n";
import copy from "copy-to-clipboard";
import { copyImageToClipboard } from "copy-image-clipboard";
import { ElMessage } from "element-plus";
dayjs.extend(isToday);
dayjs.extend(isYesterday);
dayjs.extend(relativeTime);
export const t = (key) => {
  const welcomeMessage = i18n.global.t(key);
  return welcomeMessage;
};
// 判断是否是一个图片
export function isImageUrl(url) {
  return /\.(jpg|jpeg|png|gif|bmp|svg)$/i.test(url);
}
export const formatTime = (inputTime) => {
  const { t } = useI18n();
  const now = dayjs();
  const time = dayjs(inputTime);
  const diffDays = now.diff(time, "day"); // 计算与当前时间相差的天数

  if (time.isToday()) {
    // 当天时间，返回时分
    return time.format("HH:mm");
  } else if (time.isYesterday()) {
    // 昨天，返回 "昨天 HH:mm"
    return `${t("conversation.time.yesterday")} ${time.format("HH:mm")}`;
  } else if (diffDays <= 3) {
    // 三天内（不包括昨天），返回星期几
    const weekdays = [
      t("conversation.time.sunday"),
      t("conversation.time.monday"),
      t("conversation.time.tuesday"),
      t("conversation.time.wednesday"),
      t("conversation.time.thursday"),
      t("conversation.time.friday"),
      t("conversation.time.saturday"),
    ];
    return `${weekdays[time.day()]}`;
  } else {
    // 手动处理日期格式
    const month = time.format("M"); // 获取月份
    const day = time.format("D"); // 获取日期
    return `${t("conversation.time.date_format", { month, day })}`;
  }
};
// 根据秒数转换成时分秒
export const formatMinutes = (totalSeconds) => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  let result = "";
  if (hours > 0) {
    result += `${hours}${t("common.time.hour")}`;
  }
  if (minutes > 0 || hours > 0) {
    // 如果有小时，分钟即使为0也显示
    result += `${minutes}${t("common.time.minute")}`;
  }
  result += `${seconds}${t("common.time.second")}`;

  return result;
};
// 下载
export const downloadFile = (url, fileName) => {
  console.log(url, fileName);
  const a = document.createElement("a");
  a.style.display = "none";
  document.body.appendChild(a);
  // 使用 blob + fetch 方式强制下载，解决直接打开的问题
  fetch(url)
    .then((response) => response.blob())
    .then((blob) => {
      const blobUrl = window.URL.createObjectURL(blob);
      a.href = blobUrl;
      a.download = fileName || "download";
      a.click();
      // 释放 blob URL
      window.URL.revokeObjectURL(blobUrl);
      document.body.removeChild(a);
    })
    .catch(() => {
      // 失败时退回到旧方式
      a.href = url;
      a.download = fileName || "download";
      a.click();
      document.body.removeChild(a);
    });
};
// 复制文本
export const copyText = (val) => {
  let res = copy(val, { format: "text/plain" });
  if (res) {
    // 复制成功
    ElMessage.success(t("common.copySuccess"));
  }
};
// 复制图片
export async function copyImage(url) {
  const Blob = await copyImageToClipboard(url);
  if (Blob) {
    ElMessage.success(t("common.copySuccess"));
  }
}

// 清空数据
export const clearDataByType = (target, arr) => {
  arr.forEach((i) => {
    switch (Object.prototype.toString.call(target[i]).slice(8, -1)) {
      case "String":
        target[i] = "";
        break;
      case "Array":
        target[i] = [];
        break;
      case "Object":
        target[i] = {};
        break;
      default:
        target[i] = null;
        break;
    }
  });
};

// 导出
export const exportExcel = (res) => {
  const fileNames = res.headers["content-disposition"];
  if (fileNames) {
    // 解码
    const fileName = decodeURIComponent(fileNames.match(/=(.*)$/)[1]);
    console.log(fileName);
    // 处理返回的文件流
    const content = res.data;
    const blob = new Blob([content], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    if ("download" in document.createElement("a")) {
      // 非IE下载
      const a = document.createElement("a");
      a.download = fileName;
      a.style.display = "none";
      a.href = URL.createObjectURL(blob);
      document.body.appendChild(a);
      a.click();
      URL.revokeObjectURL(a.href); // 释放URL 对象
      document.body.removeChild(a);
    } else {
      // IE10+下载
      navigator.msSaveBlob(blob, fileName);
    }
  }
};
